export default "__VITE_ASSET__BSG3viQt__"